import React, { useEffect } from 'react';
import styles from './ItemButtons.module.scss';
import { useSharedCart } from '../../entrypoints/theme';

interface ItemButtonsProps {
  cartKey: string;
  redirectUrl: string;
  freeGift?: string;
  emptyCartUrl?: string;
  bundleBuilder?: string;
}

export default function ItemButtons({ 
  cartKey, 
  redirectUrl, 
  freeGift, 
  emptyCartUrl, 
  bundleBuilder 
}: ItemButtonsProps): React.ReactElement {
  const { removeItem, cartState } = useSharedCart();

  const handleEdit = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    window.location.href = redirectUrl;
  }

  const handleRemove = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    removeItem(cartKey).then(() => {
      document.querySelectorAll(`[data-key="${cartKey}"]`).forEach(item => {
        item.remove();
      });
    });
  }

  useEffect(() => {
    if (cartState.count === 0 && emptyCartUrl && window.location.pathname === '/cart') {
      window.location.href = emptyCartUrl;
    }
  }, [cartState, emptyCartUrl]);

  return (
    <div className={styles.buttonContainer}>
      {(!freeGift || freeGift === "false") && bundleBuilder !== "yes" &&
        <button className={styles.button + ' ' + styles.editButton} onClick={handleEdit} aria-label="Edit item">
          <svg width="14" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.58471 2.34135L7.65889 4.41553M8.57016 1.42935C8.70643 1.56557 8.81453 1.72731 8.88829 1.90532C8.96204 2.08333 9 2.27412 9 2.4668C9 2.65949 8.96204 2.85028 8.88829 3.02829C8.81453 3.2063 8.70643 3.36803 8.57016 3.50426L3.59272 8.48169L1 9.00024L1.51854 6.40752L6.49598 1.43008C6.6321 1.29374 6.79375 1.18558 6.97171 1.11178C7.14966 1.03799 7.34042 1 7.53307 1C7.72572 1 7.91648 1.03799 8.09444 1.11178C8.27239 1.18558 8.43405 1.29302 8.57016 1.42935Z" stroke="black" strokeOpacity="0.7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      }
      <button className={styles.button + ' ' + styles.removeButton} onClick={handleRemove} aria-label="Remove item">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M8.61154 4.4451V3.33398H11.3893V4.4451M14.1671 6.9451V15.5562C14.1671 15.8509 14.05 16.1335 13.8417 16.3419C13.6333 16.5503 13.3507 16.6673 13.056 16.6673H6.94488C6.65019 16.6673 6.36758 16.5503 6.1592 16.3419C5.95083 16.1335 5.83377 15.8509 5.83377 15.5562V6.9451M11.3893 7.84787V15.2784M8.61154 7.84787V15.2784M4.72266 4.4451H15.2782V4.50098L4.72266 4.4451Z" stroke="black" strokeOpacity="0.7" strokeWidth="0.666667" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
}

ItemButtons.displayName = "ItemButtons";
